import React, { useState, useRef, useEffect } from "react";
import ZefiLogo from "../logo/ZefiLogo";
import cookies from "js-cookie";
import { NavItems } from "./NavItems";
import Modal from "../singlecomponents/Modal";
import "../../stylesheet/components/navbar/NavBar.scss";
import { useTranslation } from "react-i18next";
import { getRollingCoins } from "../../api/rollingCoins";
import RollingCoins from "../rollingcoins/RollingCoins";
import { RollingCoinsType } from "../../compilers/RollingCoins";
import RollingCoinsOverlay from "../rollingcoins/RollingCoinsOverlay";

const coinsToShow = [
  "btc",
  "eth",
  "bnb",
  "xrp",
  "sol",
  "ada",
  "dot",
  "avax",
  "link",
  "trix",
  "matic",
  "uni",
];
const currencyIcons = [
  { icon: "$", currency: "usd" },
  { icon: "د.إ", currency: "aed" },
  { icon: "€", currency: "eur" },
  { icon: "₹", currency: "inr" },
  { icon: "£", currency: "gbp" },
  { icon: "¥", currency: "jpy" },
  { icon: "CN¥", currency: "cny" },
  { icon: "$", currency: "nzd" },
];

const NavBar: React.FC = () => {
  const { i18n } = useTranslation();
  //const pathname = useHistory().location.pathname;

  const [click, setClick] = useState(false);
  const TopNavi = useRef<HTMLDivElement>(null);
  const RollingCoinContainer = useRef<HTMLDivElement>(null);
  const MobileMenu = useRef<HTMLDivElement>(null);
  const handleClick = () => setClick(!click);

  const [coins, setCoins] = useState<RollingCoinsType[]>([]);
  const [allCoins, setAllCoins] = useState<RollingCoinsType[]>([]);
  const [currentCurrency, setCurrentCurrency] = useState<string>("USD");
  const [icon, setIcon] = useState<string>("$");

  const getCoins = () => {
    if (getCafePath()) {
      getRollingCoins(currentCurrency.toLowerCase()).then(
        (response: RollingCoinsType[]) => {
          setAllCoins(response);
          const res = response.filter((item) =>
            coinsToShow.includes(item.symbol)
          );
          //console.log(res);
          setCoins(res);
        }
      );
    }
  };

  const checkCurrenyCookie = () => {
    const currency = cookies.get("currency") || "USD";
    setCurrentCurrency(currency);
  };

  useEffect(() => {
    checkCurrenyCookie();
  }, []);

  useEffect(() => {
    setCoins([]);
    setAllCoins([]);
    cookies.set("currency", currentCurrency);

    //call api only when in the cafe page
    getCoins();

    getCurrencyIcon(currentCurrency);

    const interval = setInterval(getCoins, 6000);

    return () => {
      clearInterval(interval);
    };
    // }
  }, [currentCurrency]);

  const getCurrencyIcon = (value: string) => {
    const icon = currencyIcons.filter(
      (item) => item.currency === value.toLowerCase()
    );
    // console.log(typeof icon[0].icon);
    setIcon(icon[0].icon);
  };

  const setNewCurrency = (newCurren: string) => {
    //console.log("Currency", newCurren);
    setCurrentCurrency(newCurren);
  };

  function getCafePath() {
    const url = location.pathname.split("/");
    if (url[2] === "cafe") return true;
    return false;
  }

  // console.log(getCurrencyIcon("aed"));

  //* When the user scrolls down, hide the navbar. When the user scrolls up, show the navbar *//
  useEffect(() => {
    let prevScrollpos = window.pageYOffset;
    window.onscroll = function () {
      const currentScrollPos = window.pageYOffset;
      if (currentScrollPos >= 70) {
        if (prevScrollpos > currentScrollPos) {
          TopNavi.current?.style ? (TopNavi.current.style.top = "0vw") : "";
          RollingCoinContainer.current?.style
            ? (RollingCoinContainer.current.style.top = "75px")
            : "";
        } else {
          !TopNavi.current?.style.getPropertyValue("position")
            ? (TopNavi.current.style.top = "-75px")
            : "";
          !RollingCoinContainer.current?.style.getPropertyValue("position")
            ? (RollingCoinContainer.current.style.top = "0px")
            : "";
        }
        prevScrollpos = currentScrollPos;
      }
      // At the bottom of page -> Show nav menu
      if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
        TopNavi.current?.style ? (TopNavi.current.style.top = "0vw") : "";
        RollingCoinContainer.current?.style
          ? (RollingCoinContainer.current.style.top = "75px")
          : "";
      }
    };
  });

  // Click hamburger menu to toggle mobile nav
  useEffect(() => {
    const mainBody = document.querySelector("body");
    if (i18n.language == "en") {
      if (click && window.innerWidth < 1024) {
        if (MobileMenu.current) MobileMenu.current.style.right = "0";
        if (MobileMenu.current) MobileMenu.current.style.left = "initial";
        if (TopNavi.current) TopNavi.current.style.position = "fixed";
        mainBody.setAttribute("style", "overflow: hidden;");
      } else {
        if (MobileMenu.current) MobileMenu.current.style.right = "-500px";
        if (TopNavi.current) TopNavi.current.style.removeProperty("position");
        mainBody.removeAttribute("style");
      }
    }

    if (i18n.language == "ar") {
      if (click && window.innerWidth < 1024) {
        if (MobileMenu.current) MobileMenu.current.style.left = "0";
        if (MobileMenu.current) MobileMenu.current.style.right = "initial";
        if (TopNavi.current) TopNavi.current.style.position = "fixed";
        mainBody.setAttribute("style", "overflow: hidden;");
      } else {
        if (MobileMenu.current) MobileMenu.current.style.left = "-500px";
        if (TopNavi.current) TopNavi.current.style.removeProperty("position");
        mainBody.removeAttribute("style");
      }
    }
  });

  // else if (MobileMenu.current && i18n.language === "ar") MobileMenu.current.style.right = "500px";

  return (
    <>
      <div className="header-wrapper">
        <header
          ref={TopNavi}
          data-testid="main-header"
          className="zefi-header shadow-sm"
        >
          <ZefiLogo
            data-testid="header-logo"
            logoPath="/img/zefi-nav-logo.svg"
            path=""
          />
          {/* <NavItems pathname={pathname} clickToCloseMenu={handleClick} /> */}
          <NavItems clickToCloseMenu={handleClick} />
          <div className="nav-hamburger" onClick={handleClick}>
            <img
              className="menu-icon"
              src="/img/icon/hamburger.svg"
              alt="Hamburger icon"
            />
          </div>
        </header>
        <div ref={MobileMenu} className="zefi-header__mobile">
          <div className="nav-hamburger" onClick={handleClick}>
            <img
              className="menu-icon"
              src="/img/icon/cross.svg"
              alt="Close icon"
            />
          </div>
          <NavItems clickToCloseMenu={handleClick} extraClass={"__mobile"} />
        </div>
      </div>

      {getCafePath() ? (
        <>
          <div
            ref={RollingCoinContainer}
            className="rolling-coin-container shadow-sm"
          >
            <RollingCoins
              coins={coins}
              currency={currentCurrency}
              icon={icon}
            />
          </div>
          <Modal ClassName="coins-overlay" targetElementName="coinOverlay">
            <RollingCoinsOverlay
              coins={allCoins}
              icon={icon}
              currency={currentCurrency}
              setCurrency={setNewCurrency}
            />
          </Modal>
        </>
      ) : (
        <div
          ref={RollingCoinContainer}
          className="rolling-coin-container"
          style={{ display: "none" }}
        ></div>
      )}
    </>
  );
};
export default NavBar;
